<template>
    <div>
        <div id="fb-root"></div>
        <div
          v-show="!hideButton"
          class="fb-login-button"
          data-onlogin="onFacebookLogin();"
          data-size="medium"
          data-button-type="login_with"
          data-layout="default"
          data-auto-logout-link="false"
          data-use-continue-as="true"
          :data-scope="facebookScope"
        ></div>
    </div>
</template>
<script>

import { HTTP_HYPER_ESPACE_BACKEND } from '@/services/http-common'

const FACEBOOK_SCOPE = 'read_insights,pages_show_list,ads_management,business_management,instagram_basic,instagram_manage_insights,instagram_content_publish,pages_read_engagement,pages_manage_posts,public_profile'

export default {
  name: 'facebookLogin',
  props: {
    onSuccess: { type: Function, required: true },
    hideButton: { type: Boolean, default: false }
  },
  data () {
    return {
      facebookClientId: '811967143434375',
      facebookConnectUrl: 'https://connect.facebook.net/fr_FR/sdk.js',
      facebookScope: FACEBOOK_SCOPE
    }
  },
  beforeMount () {
    this.loadFacebookSDK(document, 'script', 'facebook-jssdk')
    this.initFacebook()
    window.onSuccessFunction = this.onSuccess
  },
  methods: {
    async initFacebook () {
      const params = {
        appId: this.facebookClientId,
        autoLogAppEvents: true,
        xfbml: true,
        version: 'v15.0'
      }
      window.fbAsyncInit = function () { window.FB.init(params) }

      window.onFacebookLogin = () => {
        this.persistFacebookSession()
      }
    },
    persistFacebookSession () {
      if (!window.FB) {
        return
      }
      window.FB.getLoginStatus((response) => {
        if (response.status === 'connected') {
          const accessToken = response.authResponse.accessToken
          HTTP_HYPER_ESPACE_BACKEND.post('/facebook/connect', { access_token: accessToken }).then(() => {
            if (typeof window.onSuccessFunction === 'function') {
              window.onSuccessFunction()
            }
          }).catch(error => {
            console.log(error)
          })
        } else {
          console.log('getLoginStatus error')
        }
      })
    },
    /**
     * Déclenche le login Facebook depuis un bouton custom (refonte UI).
     */
    login () {
      if (!window.FB) {
        return
      }
      window.FB.login((response) => {
        if (response.status === 'connected') {
          this.persistFacebookSession()
        }
      }, { scope: FACEBOOK_SCOPE })
    },
    async loadFacebookSDK (d, s, id) {
      const fjs = d.getElementsByTagName(s)[0]
      if (d.getElementById(id)) {
        return
      }
      const js = d.createElement(s)
      js.id = id
      js.src = this.facebookConnectUrl
      fjs.parentNode.insertBefore(js, fjs)
    }
  }
}

</script>
<style>
</style>
